<template>
  <!-- 判断题 -->
  <yxt-form
    ref="ruleForm"
    :model="currentComponent"
    :rules="rules"
    label-width="100px"
    isNeedRequire
    isNeedTooltip
    label-position="top"
    size="small"
  >
    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_questionstem')"
      :prop="'content'"
      size="small"
    >
      <common-attachment-textfield
        :content.sync="currentComponent.content"
        single-limit
      />
    </yxt-form-item>

    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_options')"
      prop="questionItems"
      size="small"
      class="yxtbiz-ote-edit-ques-option"
    >
      <div class="flex flex-mid wp-100">
        <span class="mr8 width16 text-center"> A </span>
        <yxt-input
          v-model="currentComponent.judgeCorrectOptionContent"
          :maxlength="10"
          @input="inputChange"
        >
        </yxt-input>
      </div>
    </yxt-form-item>
    <yxt-form-item
      :label="''"
      prop="questionItems"
      size="small"
      class="yxtbiz-ote-edit-ques-option"
    >
      <div class="flex flex-mid wp-100 mb16">
        <span class="mr8 width16 text-center"> B </span>
        <yxt-input
          v-model="currentComponent.judgeWrongOptionContent"
          :maxlength="10"
          @input="inputChange"
        ></yxt-input>
      </div>
    </yxt-form-item>

    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_itemanswer')"
      size="small"
      prop="answer"
    >
      <yxt-radio-group v-model="currentComponent.answer" @change="changeAnswer">
        <yxt-radio
          v-for="item in currentComponent.questionItems"
          :key="item.id"
          :label="item.id"
          >{{ item.id === 0 ? 'B' : 'A' }}</yxt-radio
        >
      </yxt-radio-group>
    </yxt-form-item>
    <yxt-form-item
      size="small"
      :label="$t('pc_biz_ote_lbl_quesanalyze')"
      prop="explainText"
    >
      <common-attachment-textfield
        :content.sync="currentComponent.explainText"
        single-limit
      />
    </yxt-form-item>
  </yxt-form>
</template>

<script>
import { quesMixin } from './quesMixin';
import CommonAttachmentTextfield from './components/CommonAttachmentTextfield.vue';
import { getSafeHtmlContent } from '../../utils';
export default {
  name: 'quesJudgment',
  mixins: [quesMixin],
  components: {
    CommonAttachmentTextfield
  },
  data() {
    return {
      rules: {
        content: [{ required: true, message: this.$t('pc_biz_ote_msg_pleaseenterquestion'), trigger: 'blur' }]
      }
    };
  },
  methods: {
    changeAnswer() {
      this.$forceUpdate();
    },
    // 获取试题基本信息
    getDetail() {
      this.currentComponent.judgeCorrectOptionContent =
        this.currentComponent.judgeCorrectOptionContent ||
        this.$t('pc_biz_ote_lbl_wright');
      this.currentComponent.judgeWrongOptionContent =
        this.currentComponent.judgeWrongOptionContent ||
        this.$t('pc_biz_ote_lbl_wrong');

      this.currentComponent.questionItems = [
        {
          id: 1 // 正确
        },
        {
          id: 0
        }
      ];
      this.currentComponent.answer =
        this.currentComponent.questionItems[
          !this.currentComponent.judgeAnswer ? 1 : 0
        ].id;

      this.$nextTick(() => {
        try {
          this.$refs['editorItem' + this.index].setHtml(
            this.currentComponent.content
          );
          this.$refs['explainText' + this.index].setHtml(
            this.currentComponent.explainText
          );
        } catch (e) {}
      });
    },
    // 保存试题基本信息
    saveDetail() {
      // 编辑试题
      let isSave = false;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          isSave = true;
        } else {
          return false;
        }
      });

      if (!isSave) {
        return { error: true };
      } else {
        this.currentComponent.summary = getSafeHtmlContent(
          this.currentComponent.content
        );
        this.currentComponent.judgeAnswer = this.currentComponent.answer;
        this.currentComponent.explainText = this.currentComponent.explainText;
        this.currentComponent.judgeCorrectOptionContent =
          this.currentComponent.judgeCorrectOptionContent ||
          this.$t('pc_biz_ote_lbl_wright');
        this.currentComponent.judgeWrongOptionContent =
          this.currentComponent.judgeWrongOptionContent ||
          this.$t('pc_biz_ote_lbl_wrong');
        delete this.currentComponent.questionItems;
        this.currentComponent.answerContent = '';
        this.currentComponent.error = 0;
        this.currentComponent.errorMsg = '';
        return this.currentComponent;
      }
    }
  }
};
</script>
